import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const muangThaiCaseTransform = function(caseData) {
	const factMappingOrder = {
		"Buy for self": 10,
		"Id expiry date": 9,
		Weight: 8,
		Height: 7,
		"Health question 1": 6,
		"Health question 2": 5,
		"Health question 3": 4,
		"Health question 4": 3,
		"fatca question 1": 2,
		"fatca question 2": 1
	}
	const byOrder = (a, b) =>
		(factMappingOrder[b.type] || 0) - (factMappingOrder[a.type] || 0)
	caseData.holder.facts = caseData.holder.facts.sort(byOrder)
	caseData.insureds.forEach(i => {
		i.facts = i.facts.sort(byOrder)
	})
	console.log("transformed case", caseData)
	return caseData
}

const transformCasePerTenant = function(caseData, tenantId) {
	console.clear()
	console.log("caseData original", caseData)
	const caseDataCloned = JSON.parse(JSON.stringify(caseData))
	const tenantsTransform = {
		muangThai_uat: muangThaiCaseTransform
	}
	if (tenantsTransform[tenantId]) {
		return tenantsTransform[tenantId](caseDataCloned)
	}
	return caseData
}

export default {
	subscribe({ state, commit }, { eventName, callback }) {
		commit("ADD_SUBSCRIBER", { eventName, callback })
		const index = state.subscribers[eventName].length - 1

		return {
			unsubscribe() {
				state.subscribers.get[eventName].splice(index, 1)
			}
		}
	},

	//NOTE: Do not remove fields from this query as it could break
	// some case managements of other tenants
	// We can add things but be careful, it can have performance consequences
	async fetchCase({ rootState, commit }, { caseId }) {
		const tenantId = rootState.tenantId
		const query = gql`
			fragment Value on scalarValue {
				booleanValue
				dateValue
				stringValue
				numberValue
			}

			fragment TreeMapValues on scalarValue {
				...Value
				arrayValue {
					...Value
					objectValue {
						key
						value {
							...Value
						}
					}
				}
				objectValue {
					key
					value {
						...Value
						objectValue {
							key
							value {
								...Value
							}
						}
					}
				}
			}

			fragment relationships on relationship {
				id
				type
				entity {
					... on individual {
						...individualsFields
					}
					... on company {
						...companiesFields
					}
					... on object {
						...objectsFields
					}
					relationships {
						id
						type
						entity {
							... on individual {
								...individualsFields
							}
							... on company {
								...companiesFields
							}
							... on object {
								...objectsFields
							}
						}
					}
				}
			}

			fragment companiesFields on company {
				id
				__typename
				name
				registrationNumber
				natureOfBusiness
				source
				photoPath
				acceptsMarketing
				contacts {
					id
					type
					value
				}
				addresses {
					fields2 {
						type
						value
					}
					fields
					id
					type
				}
				identities {
					id
					type
					value
				}
				facts {
					id
					type
					value {
						...TreeMapValues
					}
				}
			}

			fragment individualsFields on individual {
				__typename
				id
				name
				photoPath
				englishFirstName
				englishLastName
				chineseFirstName
				chineseLastName
				dateOfBirth
				gender
				occupation
				maritalStatus
				employmentStatus
				salutation
				preferredCommunicationChannel
				preferredLanguage
				countryOfResidency
				incomeRange {
					exclusiveMaximum
					exclusiveMinimum
					minimum
					maximum
				}
				acceptsMarketing
				source
				internalCode
				contacts {
					id
					type
					value
				}
				identities {
					id
					type
					value
				}
				addresses {
					fields2 {
						type
						value
					}
					id
					fields
					type
				}
				facts {
					id
					type
					value {
						...TreeMapValues
					}
				}
			}

			fragment objectsFields on object {
				__typename
				id
				name
				internalCode
				photoPath
				source
				typeId
				contacts {
					id
					type
					value
				}
				addresses {
					fields2 {
						type
						value
					}
					type
					id
					fields
				}
				identities {
					id
					type
					value
				}
				facts {
					id
					type
					value {
						...TreeMapValues
					}
				}
			}

			query case($where: caseWhere) {
				cases(where: $where) {
					list {
						id
						status
						caseNumber
						component {
							name
						}
						createdAt
						lastModifiedAt
						createdBy {
							id
							username
						}
						lastModifiedBy {
							username
						}
						facts {
							id
							type
							value {
								...TreeMapValues
							}
						}
						stakeholders {
							id
							type
							entity {
								id
								name
							}
						}
						holder {
							... on individual {
								...individualsFields
							}
							... on company {
								...companiesFields
							}
							... on object {
								...objectsFields
							}
							relationships {
								...relationships
							}
						}
						insureds {
							... on individual {
								...individualsFields
							}
							... on company {
								...companiesFields
							}
							... on object {
								...objectsFields
							}
							relationships {
								...relationships
							}
						}
						otherHolders {
							... on individual {
								...individualsFields
							}
							... on company {
								...companiesFields
							}
							... on object {
								...objectsFields
							}
							relationships {
								...relationships
							}
						}
						beneficiaryEligibilities {
							notes
							entity {
								id
								name
								relationships {
									type
									entity {
										id
									}
								}
							}
							id
							ratio
						}
						paymentInfos {
							id
							name
							comment
							currencyCode
							amount
							method
							frequency
							payor {
								id
								name
								identities {
									id
									type
									value
								}
							}
						}
					}
				}
			}
		`
		const res = await api({ query, variables: { where: { id: caseId } } })
		let caseData = res?.data?.cases?.list?.[0] || {}
		caseData = transformCasePerTenant(caseData, tenantId)
		commit("SET_CASE", caseData) // Save all data in store

		return Promise.resolve(res)
	},

	//NOTE: Do not remove fields from this query as it could break
	// some case managements of other tenants
	// We can add things but be careful, it can have performance consequences
	async fetchProposals(
		{ state, commit },
		{ caseId, options = { currencyCodes: [] } }
	) {
		console.log("Fetching proposals")

		const query = gql`
			fragment Value on scalarValue {
				booleanValue
				dateValue
				stringValue
				numberValue
			}

			fragment TreeMapValues on scalarValue {
				...Value
				arrayValue {
					...Value
					objectValue {
						key
						value {
							...Value
						}
					}
				}
				objectValue {
					key
					value {
						...Value
					}
				}
			}

			fragment BenefitNode on benefitGraph {
				name
				description
				isOptional
				isValueInput
				optionKey
				typeId
				formattedValue: value
				value: value2 {
					...TreeMapValues
				}
			}

			fragment pricing on pricing {
				amount
				currencyCode
				formattedPrice
				originalPrice
				formattedOriginalPrice
				appliedTaxes {
					code
					name
					ratio
					flat
					formattedFlat
					order
					formattedOriginalPrice
					originalPrice
				}
				appliedDiscounts {
					id
					name
					code
					ratio
					flat
					formattedFlat
					order
					formattedOriginalPrice
					originalPrice
				}
				loadings {
					id
					codeName {
						code
						name
					}
					ratio
					flat
					order
				}
				paymentFrequency
			}

			query proposals(
				$where: caseWhere
				$options: exchangeRateConversionOptionsInput!
			) {
				cases(where: $where) {
					list {
						proposals {
							id
							name
							createdAt
							lastModifiedAt
							proposalNumber
							referralCode
							createdBy {
								username
							}
							lastModifiedBy {
								username
							}
							proposalNumber
							totalPrice {
								formattedPrice
								currencyCode
							}
							rejectionCodes {
								code
								name
							}
							rejectionRemarks
							renewalHistory {
								renewalCount
								renewedFrom {
									id
									name
									createdAt
									proposalNumber
								}
								renewedTo {
									id
									name
									createdAt
									proposalNumber
								}
							}
							status
							isIssued
							basket {
								id
								createdAt
								createdBy {
									username
								}
								lastModifiedAt
								lastModifiedBy {
									username
								}
								associatedContracts {
									id
									contract {
										name
										id
										commissionRule {
											jsonRule
										}
									}
								}
								stakeholders {
									id
									entity {
										name
									}
									type
								}
								status
								startDate
								endDate
								facts {
									id
									type
									value {
										...TreeMapValues
									}
								}
								commissionSplitRules {
									id
									entity {
										__typename
										id
										name
									}
									baseCommissionRatio {
										ratio
									}
									currencyCode
									amount
									ratio
									type
									entity {
										name
									}
									jsonRule
								}
								commissionSummary {
									currencyCode
									amount
									ratio
									jsonRule
									type
									entity {
										__typename
										id
										name
									}
								}
								benefitOptions {
									benefitTypeId
									value {
										stringValue
										numberValue
										booleanValue
										dateValue
									}
									formattedValue
									key
									name
								}
								benefitSummary {
									benefitGraphs {
										name
										...BenefitNode
										children {
											...BenefitNode
											children {
												...BenefitNode
												children {
													...BenefitNode
												}
											}
										}
									}
								}
								premium {
									...pricing
									convertedPrices(options: $options) {
										...pricing
									}
								}
								exclusions {
									id
									codeName {
										code
										name
									}
									remark
								}
								product {
									name
									insurer {
										name
									}
									productId {
										plan
										type
										version
									}
								}
							}
						}
					}
				}
			}
		`

		const res = await api({
			query,
			variables: { where: { id: caseId }, options }
		})
		commit("SET_PROPOSALS", res?.data?.cases?.list?.[0]?.proposals || []) // Save all data in store

		return Promise.resolve(res)
	}
}
